import ManageKPIReviewCustom from "../../../../components/manageKPIReview/manageKPIReviewConfig/ManageKPIReviewCustom";
import { AppNonStandardCustom } from "../appNonStandardConfig/appNonStandardCustom";
import ChannelTypeFilter from "../DistributorFilters/ChannelFilter";
import FullHerirarchy from "../DistributorFilters/ReplEdititingFilters/FullHerirarchy";
import SalesManTypeFilter from "../DistributorFilters/SalesManFilter";
import WeekDaysTypeFilter from "../DistributorFilters/WeekDaysFilter";
import MustDoActionConfigCustom from "../mustDoActions/components/MustDoActionCustom";
import {CartMissedItemBasket,CartOrderFulfillmentTime,CartOrderFulfillmentType,CartOrderingCriteria} from "../optionalFeatures/cartConfiguration/components/CartConfigCustom";
import {CatalogueConfigCustomDummyImageUpload,CatalogueConfigCustomFilter,CatalogueConfigCustomLabels,CatalogueConfigCustomPriceFormatted,CatalogueConfigCustomSimilarProductGrouping,CatalogueConfigCustomSkuTile} from "../optionalFeatures/catelogueConfig/CatalogueConfigCustom";
import OrderSummaryConfigCustom from "../optionalFeatures/orderSummary/OrderSummaryConfigCustom";
import OrderTrackingConfigCustom from "../optionalFeatures/OrderTrackingConfig/OrderTrackingConfigCustom";
import {PasswordComplexityCustom,PasswordDeactivateInactiveUsers,PasswordRetry,} from "../PasswordConfiguration/passwordConfigurationCustom";
import ProjectConfigCustom, {ProjectConfigCustomLob,ProjectDevelopedConfigurations,} from "../projectConfig/ProjectConfigCustom";

interface Props {
  values: any;
  name: string;
  setValues: React.Dispatch<React.SetStateAction<any>>;
  extraValues?: any;
  setExtraValues?: React.Dispatch<React.SetStateAction<any>>;
  defaultValues?: any;
  setAreDataFieldsValid?: (isValid: boolean) => void;
}

const CustomMap: Record<string, any> = {
  ordertracking_ordertrackingstages: OrderTrackingConfigCustom,
  cart_orderfulfillmenttype: CartOrderFulfillmentType,
  cart_orderfulfillmenttime: CartOrderFulfillmentTime,
  cart_misseditembasket: CartMissedItemBasket,
  cart_orderingcriteriatype: CartOrderingCriteria,
  catalogue_catalogue: CatalogueConfigCustomFilter,
  ordersummary_ordertnclink: OrderSummaryConfigCustom,
  uiandtheme_appbarbackgroundtype: AppNonStandardCustom,
  project_countrycode: ProjectConfigCustom,
  project_lob: ProjectConfigCustomLob,
  mustdoaction_mustdoactioncard: MustDoActionConfigCustom,
  kpireview_kpiconfiglist: ManageKPIReviewCustom,
  catalogue_showskucode: CatalogueConfigCustomSkuTile,
  catalogue_similarproduct: CatalogueConfigCustomSimilarProductGrouping,
  catalogue_dummyimageupload: CatalogueConfigCustomDummyImageUpload,
  catalogue_labels: CatalogueConfigCustomLabels,
  catalogue_priceformatter: CatalogueConfigCustomPriceFormatted,
  projectnonstandard_developerconfigurations: ProjectDevelopedConfigurations,
  projectnonstandard_countrycode: ProjectConfigCustom,
  authentication_passwordcomplexity: PasswordComplexityCustom,
  authentication_userloginblock: PasswordRetry,
  authentication_userinactivityblock: PasswordDeactivateInactiveUsers,
  orderedit_distributor:FullHerirarchy,
  invoiceediting_channel:ChannelTypeFilter,
  geofencing_salesmen:SalesManTypeFilter,
  manualediting_distributor:FullHerirarchy,
  geofencing_distributor:FullHerirarchy,
  manualediting_weekdays:WeekDaysTypeFilter,
};

const CustomComponentMapping: React.FC<Props> = (props) => {
  const Component = CustomMap[props.name];
  if (!Component) return null;

  return <Component {...props} />;
};

export default CustomComponentMapping;
